import React, {useState, useEffect} from "react";
import Modal from "react-modal";
import Web3 from "web3";
import Staking from '../abi/Staking.json'
import Swal  from "sweetalert2";
import { parseUnits } from "ethers";
import { txAfterDone, txDone, txStart } from '../../../helper/Helper';

const LockPopup = ({ modalIsOpen, closeModal, account, providers, unlockedpTGC, updatePage}) => {
  const [amount, setAmount] = useState('');
  const [duration, setDuration] = useState('');

  useEffect(() => {
      if (Number(amount) > unlockedpTGC) 
      {
          setAmount(unlockedpTGC)
      }
      if (String(amount).includes(".")) 
      {
          let input_string = String(amount)
          let newAmount = input_string.match(/^\d+\.\d{0,0}/)[0]
          setAmount(Number(newAmount))
      }
  }, [amount, unlockedpTGC]);

  const lockToken = async () => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    const finalAmount = parseUnits(String(amount), 18);
    const finalDuration = duration * 86400;
    if (duration < 90) {
      Swal.fire({
        title: "Please try again",
        text: "Minimum lock duration is 90 days",
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Ok",
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-danger"
        }
      });
    } else {
      try {
        await stakingContract.methods.lock(String(finalAmount), String(finalDuration)).send({
          from: account
        }).on('transactionHash', function(payload) {
          closeModal();
          txStart();
        }).on('error', function(error) {
          Swal.fire({
            title: "Please try again",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "Ok",
            showCloseButton: true,
            customClass: {
              confirmButton: "btn btn-danger"
            }
          });
        }).then(function(receipt) {
          updatePage()
          txDone()
          setTimeout(() => {
            txAfterDone()
          }, 2000)
        });
      } catch (error) {
        txDone();
        txAfterDone();
        Swal.fire({
          title: "Please try again",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Ok",
          showCloseButton: true,
          customClass: {
            confirmButton: "btn btn-danger"
          }
        });
      }
    }
  }

  const afterOpenModal = () => {
    setAmount('');
    setDuration('');
  };
  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} onAfterOpen={afterOpenModal} contentLabel="Modal">
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="PTGCSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="mb-0 mt-2  w-100 good_times goldFont">Lock PTGC</h2>
            </div>
              <div className="row justify-content-center mt-4">
                <div className="col-sm-12 col-md-6 col-lg-5">
                  <div className="">
                  <div className="bSRIN overHide p-0">
                  <div className="bSRIN overHide mt-0 w-5100" style={{ border: '0px', borderRadius:'0px', borderBottom: '0px solid #383835' }}>
                    <div className="amountSTaking d-flex1 justify-content-between align-items-center gap-3" >
                      <div className="perVal fInter d-flex align-items-center mt-3 mb-1"><span className="">Available Amount : <span className="text-white">{parseFloat(unlockedpTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PTGC</span></span></div>
                      <div className="inputBGCOin d-flex gap-2 w-100">
                        <img className="img-fluid" src="./images/ptgccircle.svg" />
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder="0.00"
                          value={
                            amount === "" || isNaN(Number(amount.toString().replace(/,/g, "")))
                              ? ""
                              : Number(amount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setAmount("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(unlockedpTGC));
                            setAmount(num.toString());
                          }}
                        />
                      </div>
                      <div className="perVal fInter d-flex align-items-center mt-3 mb-1"><span className="">Lock Duration : <span className="text-white">Minimum 90 Days</span></span></div>
                      <div className="inputBGCOin d-flex gap-2 w-100">
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder="0"
                          value={
                            duration === "" || isNaN(Number(duration.toString().replace(/,/g, "")))
                              ? ""
                              : Number(duration.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setDuration("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(3650));
                            setDuration(num.toString());
                          }}
                        />
                      </div>
                      <div className="someBtns d-flex gap-2 mt-3 modnoCOlo">
                        <button className="someSnbtn w-100" onClick={() => { setAmount((25 / 100) * unlockedpTGC) }}><span>25%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((50 / 100) * unlockedpTGC) }}><span>50%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((75 / 100) * unlockedpTGC) }}><span>75%</span></button>
                        <button className="someSnbtn w-100" onClick={() => { setAmount((100 / 100) * unlockedpTGC) }}><span>100%</span></button>
                      </div>
                    </div>
                  </div>
                  <div className="someBtns SRTOP  d-flex gap-2 mt-0 p-2">
                    {
                      amount > 0 && duration >= 90 ?
                      <>
                        <button className="someSnbtn" onClick={() => {lockToken()}}>
                          <span className="d-flex align-items-center w-100 justify-content-between">Lock Now
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/PlusCircle.svg" />
                            </div>
                          </span>
                        </button>
                      </>
                      :
                      <>
                        <button className="someSnbtn" disabled>
                          <span className="d-flex align-items-center w-100 justify-content-between">Lock Now
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/PlusCircle.svg" />
                            </div>
                          </span>
                        </button>
                      </>
                    }
                  </div>
                </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      </div>
    </Modal>
    </>
  );
};

export default LockPopup;